// a generic class to hold vehicle / driver group membership for an account user
export class UserAssociatedGroup {
  groupId: number;
  groupName: string;
  numMembers: number;
  toString(): string {
    return this.groupName;
  }
}
